import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Lock, Download, Printer } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function PricingSection() {
  const handleCheckoutClick = () => {
    trackAddToCart({
      content_name: 'The Quiet Bladder Reset',
      content_type: 'product',
      value: 6.36,
      currency: 'USD'
    });
  };
  return <section id="pricing" className="w-full bg-warm-gray pt-16 pb-8 px-6 md:pt-24 md:pb-8" data-id="element-151">
      <div className="max-w-reading mx-auto text-center" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-12 rounded-2xl shadow-xl border border-border-gray relative z-10" data-id="element-153">
          <div className="mb-8" data-id="element-154">
            <p className="text-lg text-charcoal/50 line-through mb-1 font-serif" data-id="element-155">
              $27.00
            </p>
            <span className="text-6xl font-bold text-charcoal font-serif" data-id="element-156">
              $6.36
            </span>
            <div className="mt-3 inline-flex items-center gap-1.5 bg-sage/15 text-sage-dark text-sm font-bold px-4 py-1.5 rounded-full" data-id="element-157">
              You save $20.64 (76% off)
            </div>
            <p className="text-lg text-charcoal/60 mt-3" data-id="element-158">
              Instant digital download.
            </p>
          </div>

          <a href="https://www.betterbysteps.com/cart/44199612252253:1" target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} className="w-full bg-amber hover:bg-amber-hover text-white text-xl md:text-2xl font-bold py-5 px-8 rounded-lg shadow-md transition-all transform hover:scale-[1.02] flex items-center justify-center gap-2 mb-6 no-underline" data-id="element-159">
            Download The Quiet Bladder Reset
          </a>

          <div className="flex flex-wrap justify-center gap-4 text-sm text-charcoal/70" data-id="element-160">
            <span className="flex items-center gap-1" data-id="element-161">
              <Download className="w-4 h-4" data-id="element-162" /> Instant download
            </span>
            <span className="hidden md:inline" data-id="element-163">•</span>
            <span className="flex items-center gap-1" data-id="element-164">
              <Printer className="w-4 h-4" data-id="element-165" /> Printable tracker included
            </span>
            <span className="hidden md:inline" data-id="element-166">•</span>
            <span className="flex items-center gap-1" data-id="element-167">
              <Lock className="w-4 h-4" data-id="element-168" /> Private, no embarrassment
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}